<template>
    <el-col :span="4" :lg="6" :push="1">
        <el-dialog width="1000" title="Invoice Sample Data" :visible="dialogTableVisible" @close="$emit('onClose')">
            <el-table :data="gridData">
                <el-table-column property="reference" label="Reference" width="100"></el-table-column>
                <el-table-column property="invoiceDate" label="Invoice Date" width="110"></el-table-column>
                <el-table-column property="customerName" label="Customer Name" width="130"></el-table-column>
                <el-table-column property="amount" label="Amount" width="80"></el-table-column>
                <el-table-column property="currencyCode" label="Currency Code" width="125"></el-table-column>
                <el-table-column property="introduction" label="Introduction" width="110"></el-table-column>
                <el-table-column property="productNumber" label="Product Number" width="130"></el-table-column>
                <el-table-column property="quantity" label="Quantity" width="80"></el-table-column>
                <el-table-column property="price" label="Price" width="60"></el-table-column>
                <el-table-column property="accountCode" label="Account Code" width="120"></el-table-column>
                <el-table-column property="taxType" label="Tax type" width="80"></el-table-column>
                <el-table-column property="tax" label="Tax" width="80"></el-table-column>
                <el-table-column property="invoiceDueDate" label="Invoice Due Date" width="110"></el-table-column>
                <el-table-column property="invoiceNumber" label="Invoice Number" width="110"></el-table-column>
            </el-table>
            <div style="text-align: center">
                <p>Invoice date format should be <b>MM/dd/yyyy</b> format. You can download sample file <a href="https://s3.amazonaws.com/workforcetrack/000000000000/invoice-import-app/public/Invoice_Import_Template.csv">here</a> </p>
            </div>
        </el-dialog>
    </el-col>
</template>


<script>
    export default {
        props: {
            dialogTableVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                gridData: [
                    {
                        reference: 'Reference 1',
                        invoiceDate: '01/30/2019',
                        customerName: 'John Smith',
                        amount: '500',
                        currencyCode: 'USD',
                        introduction: 'Introduction 1',
                        productNumber: 'PR001',
                        quantity: '1',
                        price: '100',
                        accountCode: '4000',
                        taxType: 'TAX INCLUSIVE',
                        tax: 'VAT 12%',
                        invoiceDueDate: '02/30/2019',
                        invoiceNumber: 'INV001'
                    },
                    {
                        reference: 'Reference 1',
                        invoiceDate: '01/30/2019',
                        customerName: 'John Smith',
                        amount: '500',
                        currencyCode: 'USD',
                        introduction: 'Introduction 1',
                        productNumber: 'PR002',
                        quantity: '2',
                        price: '200',
                        accountCode: '4000',
                        taxType: 'TAX INCLUSIVE',
                        tax: 'VAT 12%',
                        invoiceDueDate: '02/30/2019',
                        invoiceNumber: 'INV001'
                    },
                    {
                        reference: 'Reference 2',
                        invoiceDate: '01/30/2019',
                        customerName: 'John Adam',
                        amount: '2500',
                        currencyCode: 'USD',
                        introduction: 'Introduction 3',
                        productNumber: 'PR003',
                        quantity: '3',
                        price: '300',
                        accountCode: '4000',
                        taxType: 'TAX INCLUSIVE',
                        tax: 'VAT 12%',
                        invoiceDueDate: '02/30/2019',
                        invoiceNumber: 'INV001'
                    },
                    {
                        reference: 'Reference 2',
                        invoiceDate: '01/30/2019',
                        customerName: 'John Adam',
                        amount: '2500',
                        currencyCode: 'USD',
                        introduction: 'Introduction 4',
                        productNumber: 'PR004',
                        quantity: '4',
                        price: '400',
                        accountCode: '4000',
                        taxType: 'TAX INCLUSIVE',
                        tax: 'VAT 12%',
                        invoiceDueDate: '02/30/2019',
                        invoiceNumber: 'INV001'
                    }

                ],
                dialogFormVisible: false
            };
        }
    };
</script>


// WEBPACK FOOTER //
// InvoicePopup.vue?c594f1a8